
import { defineComponent, reactive, watch, PropType } from 'vue'
import JrCheckbox from '@/components/jr-parts/JrCheckbox.vue'
import { ListRequest } from '@/requests/answerDraftItem'
import { AnswerItemList } from '@/requests/answerItem'
import { AxiosResponse } from 'axios'
import { AnswerDraftCategoryForm, RequestHeaderProximityForm } from '@/types/forms'
import { AnswerItem } from '@/api'

export default defineComponent({
  name: 'AnswerDraftCheckBox',
  emits: ['update:modelValue'],

  components: {
    JrCheckbox,
  },
  props: {
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: true,
    },
    modelValue: {
      type: Array as PropType<number[]>,
      required: true,
    },
    proximity: {
      type: Object as PropType<RequestHeaderProximityForm>,
      required: true,
    },
  },
  setup(props, context) {
    const answerDrafts = reactive<Array<AnswerDraftCategoryForm>>([])

    /**
     * 初期表示時、回答候補一覧を取得
     */
    watch(
      () => props.requestHeaderId,
      async () => {
        //回答候補一覧取得
        const request = new ListRequest()
        await request.exec()
        if (request.success) {
          const { data } = request.getResponse() as AxiosResponse<Array<AnswerDraftCategoryForm>>
          data.forEach((category) => {
            category.answer_draft_item.forEach((item) => {
              item.checked = false
            })
          })
          answerDrafts.push(...data)
          //回答保存ID取得
          if (props.proximity.proximity.proximity_id !== undefined) {
            const answerItemRequest = new AnswerItemList(props.proximity.proximity.proximity_id.toString())
            await answerItemRequest.exec()
            if (answerItemRequest.success) {
              const { data } = answerItemRequest.getResponse() as AxiosResponse<Array<AnswerItem>>
              answerDrafts.forEach((category) => {
                category.answer_draft_item.forEach((item) => {
                  //取得した保存IDと一致する場合はTrue
                  item.checked = data.some((obj) => item.answer_draft_item_id == obj.answer_draft_item)
                })
              })
            }
          }
        }
      },
      { immediate: true }
    )

    /**
     * 選択した回答案のリストを生成
     */
    watch(
      () => answerDrafts,
      () => {
        //checkしたanswer_draft_item_idを親コンポネントに送信
        //結果の空配列
        const answerDraftItems: number[] = []
        //checked === trueならanswer_draft_item_idを結果配列にpush
        answerDrafts.forEach((category) => {
          category.answer_draft_item.forEach((item) => {
            if (item.checked === true) {
              answerDraftItems.push(item.answer_draft_item_id as number)
            }
          })
        })
        context.emit('update:modelValue', answerDraftItems)
      },
      {
        deep: true,
      }
    )
    /**
     * modelValueに格納されている回答項目IDに
     * チェックを入れる
     */
    watch(
      () => props.modelValue,
      () => {
        answerDrafts.forEach((category) => {
          category.answer_draft_item.forEach((item) => {
            //props.storeAnswerItems同じIDがあるかチェック
            item.checked = props.modelValue.some((id) => item.answer_draft_item_id == id)
          })
        })
      },
      { deep: true }
    )
    return {
      answerDrafts,
    }
  },
})
